import type { FC, ReactNode } from 'react'

import { useMemo } from 'react'
import { cn } from '@/lib/utils'

import { EDGE_COLUMNS, EDGE_HEIGHT, buildEdgePath } from '@/constants/sprites'

interface PixelEdgeProps {
    color: string
    seed?: number
    flip?: boolean
    className?: string
}

/**
 * Jagged "pixel grass" edge. Pixels stay square at any width: the svg is sliced, not stretched.
 * Place it inside a relative section, e.g. absolute bottom-[calc(100%-1px)] to rise out of its top.
 */
const PixelEdge: FC<PixelEdgeProps> = ({
    color,
    seed = 7,
    flip = false,
    className
}): ReactNode => {
    const d = useMemo(() => buildEdgePath(seed), [seed])

    return (
        <svg
            viewBox={`0 0 ${EDGE_COLUMNS} ${EDGE_HEIGHT}`}
            preserveAspectRatio='xMidYMax slice'
            shapeRendering='crispEdges'
            aria-hidden='true'
            focusable='false'
            className={cn('pointer-events-none block h-12 w-full md:h-16', flip && '-scale-y-100', className)}
        >
            <path d={d} style={{ fill: color }} />
        </svg>
    )
}

export default PixelEdge
